import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
  }).format(amount);
}

export function formatDate(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
}

export function formatDateTime(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

export function getStatusColor(status) {
  switch (status) {
    case 'aprobado':
      return 'status-aprobado';
    case 'rechazado':
      return 'status-rechazado';
    case 'pendiente':
      return 'status-pendiente';
    case 'vencido':
      return 'status-vencido';
    case 'revisado':
      return 'bg-amber-50 text-amber-700 border-amber-200';
    case 'borrador':
    default:
      return 'status-borrador';
  }
}

export function getStatusLabel(status) {
  switch (status) {
    case 'aprobado':
      return 'Aprobado';
    case 'rechazado':
      return 'Rechazado';
    case 'pendiente':
      return 'Pendiente';
    case 'vencido':
      return 'Vencido';
    case 'revisado':
      return 'Revisado';
    case 'borrador':
      return 'Borrador';
    default:
      return status;
  }
}

export function getStatusIcon(status) {
  switch (status) {
    case 'aprobado':
      return '🟢';
    case 'rechazado':
      return '🔴';
    case 'pendiente':
      return '🟡';
    case 'vencido':
      return '⏰';
    case 'borrador':
      return '📝';
    default:
      return '•';
  }
}

export function truncate(str, length = 50) {
  if (!str) return '';
  if (str.length <= length) return str;
  return str.slice(0, length) + '...';
}

export function formatDistanceToNow(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffSecs = Math.floor(diffMs / 1000);
  const diffMins = Math.floor(diffSecs / 60);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffSecs < 60) return 'hace unos segundos';
  if (diffMins < 60) return `hace ${diffMins} min`;
  if (diffHours < 24) return `hace ${diffHours}h`;
  if (diffDays === 1) return 'ayer';
  if (diffDays < 7) return `hace ${diffDays} días`;
  return formatDate(dateString);
}
